var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid manual-assign-container" }, [
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "manual-assign" },
          [
            _c(
              "div",
              {
                staticClass: "blocked-overlay",
                class: { active: _vm.isBlocked },
                style: { top: _vm.$isFullscreen ? 0 : "60px" },
              },
              [
                _c("div", { staticClass: "body" }, [
                  _c("h1", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.autoAssignUsername
                            ? _vm.autoAssignUsername
                            : _vm.$t("planning.messages.someone")
                        ) +
                        " " +
                        _vm._s(_vm.$t("planning.messages.autoAssignOccupied")) +
                        " "
                    ),
                  ]),
                ]),
              ]
            ),
            _c(
              "el-dialog",
              {
                attrs: { visible: _vm.isShowFailedOrders },
                on: {
                  "update:visible": function ($event) {
                    _vm.isShowFailedOrders = $event
                  },
                },
              },
              _vm._l(_vm.failedOrders, function (item, index) {
                return _c("div", { key: index }, [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "planning.autoAssignInvalidReasons." + item.reason
                        )
                      )
                    ),
                  ]),
                  _c("p", [
                    _c("b", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "planning.autoAssignInvalidReasons.followingShipmentReference"
                          )
                        )
                      ),
                    ]),
                    _vm._v(
                      " " + _vm._s(item.shipmentReference.join(", ")) + " "
                    ),
                  ]),
                  _c("br"),
                ])
              }),
              0
            ),
            !_vm.$isOrderFullscreen
              ? _c(
                  "el-row",
                  { attrs: { type: "flex" } },
                  [
                    _c(
                      "el-col",
                      {
                        staticClass: "section-container plan-header-container",
                        style: _vm.planHeaderStyle,
                      },
                      [
                        _c("plan-header", {
                          attrs: { type: "manual" },
                          on: { onManualAssignTruck: _vm.handleManualAssign },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-row",
              { style: _vm.planBodyStyle, attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  {
                    attrs: {
                      xs: 24,
                      sm: 24,
                      md: { span: !_vm.$isOrderFullscreen ? 16 : 24 },
                    },
                  },
                  [
                    _c(
                      "el-row",
                      {
                        staticClass: "h-100",
                        staticStyle: { "flex-flow": "column wrap" },
                        attrs: { type: "flex" },
                      },
                      [
                        _c(
                          "el-col",
                          {
                            staticClass:
                              "section-container d-none d-md-inline-block pt-0",
                            attrs: { span: 24 },
                          },
                          [
                            _c(
                              "el-row",
                              {
                                staticClass: "h-100",
                                staticStyle: { "flex-flow": "column wrap" },
                                attrs: { type: "flex" },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c(
                                      "el-row",
                                      { attrs: { type: "flex", gutter: 4 } },
                                      [
                                        _c(
                                          "el-col",
                                          {
                                            attrs: {
                                              xs: 24,
                                              sm: 24,
                                              md: 24,
                                              lg: 12,
                                            },
                                          },
                                          [_c("order-date-range")],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          {
                                            attrs: {
                                              xs: 24,
                                              sm: 24,
                                              md: 24,
                                              lg: 12,
                                            },
                                          },
                                          [_c("order-filter")],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("order-filter-tag", {
                                      attrs: { type: "manual" },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("order-table", {
                                      attrs: {
                                        tableHeight: !_vm.$isOrderFullscreen
                                          ? "500px"
                                          : "calc(100vh - 130px)",
                                      },
                                      on: {
                                        onFailedOrders: _vm.handleFailedOrders,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        !_vm.$isOrderFullscreen
                          ? _c(
                              "el-col",
                              {
                                staticClass: "section-container",
                                staticStyle: { "flex-grow": "1" },
                                attrs: { span: 24 },
                              },
                              [
                                _c(
                                  "el-row",
                                  {
                                    staticClass: "h-100",
                                    staticStyle: { "flex-flow": "column wrap" },
                                    attrs: { type: "flex" },
                                  },
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "d-none d-md-inline-block",
                                        attrs: { span: 24 },
                                      },
                                      [
                                        _c("gantt-filter", {
                                          attrs: {
                                            isEnableAllTrucks:
                                              _vm.isEnableAllTrucks,
                                          },
                                          on: {
                                            onEnableAllTrucks:
                                              _vm.handleEnableAllTrucks,
                                            onDisableAllTrucks:
                                              _vm.handleDisableAllTrucks,
                                            onTimeStepperChanges:
                                              _vm.handleTimeStepperChanges,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      {
                                        staticStyle: {
                                          "flex-grow": "1",
                                          "margin-top": "0.5rem",
                                        },
                                        attrs: { span: 24 },
                                      },
                                      [
                                        _c("gantt-chart", {
                                          attrs: {
                                            defaultTimeStepper: _vm.timeStepper,
                                            isEnableAllTrucks:
                                              _vm.isEnableAllTrucks,
                                            initAutoAddedDays:
                                              _vm.initAutoAddedDays,
                                            currentPlanId: _vm.currentPlanId,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                !_vm.$isOrderFullscreen
                  ? _c(
                      "el-col",
                      { attrs: { xs: 24, sm: 24, md: 8 } },
                      [
                        _c(
                          "el-row",
                          {
                            staticStyle: {
                              height: "100%",
                              "flex-flow": "column",
                            },
                            attrs: { type: "flex" },
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticClass:
                                  "section-container d-none d-md-inline-block",
                                attrs: { span: 24 },
                              },
                              [
                                _c("plan-search", {
                                  on: {
                                    onSearchValueIsFound:
                                      _vm.handleSearchValueIsFound,
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              {
                                staticClass: "section-container",
                                staticStyle: { flex: "0 1 auto" },
                                attrs: { span: 24 },
                              },
                              [_c("order-summary")],
                              1
                            ),
                            _c(
                              "el-col",
                              {
                                staticClass: "section-container",
                                staticStyle: { flex: "1 1 auto" },
                                attrs: { span: 24 },
                              },
                              [
                                _c("truck-summary", {
                                  attrs: { selectedPlanId: _vm.selectedPlanId },
                                  on: {
                                    onFailedOrders: _vm.handleFailedOrders,
                                    onRecalculateTimeList:
                                      _vm.recalculateTimeList,
                                    onCurrentPlanIdChanges:
                                      _vm.handleCurrentPlanIdChanges,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }